import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface PolylineDistanceTooltipCoords {
    value: [][];
}

const initialState: PolylineDistanceTooltipCoords = {
    value: [],
};

export const polylineDistanceTooltipCoordsSlice = createSlice({
    name: 'polylineDistanceTooltipCoordsSetter',
    initialState,
    reducers: {
        setPolylineDistanceTooltipCoords: (state, action: PayloadAction<[]>) => {
            state.value = action.payload.length === 0 ? [] : [...state.value, action.payload];
        },
        updatePolylineDistanceTooltipCoords: (state, action: PayloadAction<any>) => {
            const parsedState = JSON.parse(JSON.stringify(state.value));
            const payload = action.payload;
            state.value = parsedState.filter((polyline: any) => {
                return !payload.includes(polyline.id);
            });
        },
    },
});

export const { setPolylineDistanceTooltipCoords, updatePolylineDistanceTooltipCoords } =
    polylineDistanceTooltipCoordsSlice.actions;
export default polylineDistanceTooltipCoordsSlice.reducer;
